import { render, staticRenderFns } from "./rankUserList.vue?vue&type=template&id=2bf88290&scoped=true"
import script from "./rankUserList.vue?vue&type=script&lang=js"
export * from "./rankUserList.vue?vue&type=script&lang=js"
import style0 from "./rankUserList.vue?vue&type=style&index=0&id=2bf88290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf88290",
  null
  
)

export default component.exports